import { Component } from '@angular/core';
import { InfoLinks } from '@sondermind/core/enums/info-links.enum';

@Component({
  selector: 'intake-footer',
  templateUrl: './intake-footer.component.html',
  styleUrls: ['./intake-footer.component.scss']
})
export class IntakeFooterComponent {
  emergencyResources = InfoLinks.EMERGENCY_RESOURCES;
}
